jQuery(document).ready(function () {
    "use strict";
    ldEqualHeightSlides();
});

jQuery(window).resize(function(){
    "use strict";
    ldEqualHeightSlides();
});


function ldEqualHeightSlides() {

    jQuery('.four-product-slider-1__slider').each(function(){

        var highestBox = 0;

        jQuery(this).find('.loop-product').each(function(){
            jQuery(this).height('auto');

            if(jQuery(this).height() > highestBox){
               highestBox = jQuery(this).height();
            }
        })

        jQuery(this).find('.loop-product').height(highestBox);
    });

    jQuery('.up-sells__slider').each(function(){
        var highestBox = 0;

        jQuery(this).find('.up-sells__col').each(function(){
            jQuery(this).height('auto');

            if(jQuery(this).height() > highestBox){
               highestBox = jQuery(this).height();
            }
        })

        jQuery(this).find('.up-sells__col').height(highestBox);
    });
}
